module.exports = __webpack_public_path__ + "7afb1b3be2c8eefe316c73e7c3a495d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructors/images/luciano-mammino.jpg
// module id = 34
// module chunks = 0 1